import React from 'react';
import { Box, Flex, Text, VStack, Image, Button } from '@chakra-ui/react';
export function BrandStory() {
  return <Box as="section" data-id="element-2">
      {/* PART 1 — Meet Ashley Nicole */}
      <Box bg="white" py={20} px={{
      base: 6,
      md: 12,
      lg: 20
    }} data-id="element-3">
        <Flex maxW="1100px" mx="auto" direction={{
        base: 'column',
        md: 'row'
      }} align="center" gap={16} data-id="element-4">
          {/* Left: Image */}
          <Box flex="0 0 auto" w={{
          base: '100%',
          md: '460px'
        }} maxW={{
          base: '400px',
          md: '460px'
        }} mx={{
          base: 'auto',
          md: 0
        }} data-id="element-5">
            <Box aspectRatio="4/5" overflow="hidden" borderRadius="12px" boxShadow="0 8px 32px rgba(201,146,157,0.25)" data-id="element-6">
              <Image src="https://cdn.magicpatterns.com/uploads/4p9huyq4JWAeaEKvuTiSEo/631805040_18079020404599200_8442927630864201814_n.jpg" alt="Ashley Nicole, founder of Love & xx's" w="100%" h="100%" objectFit="cover" fallback={<Box w="100%" h="100%" display="flex" alignItems="center" justifyContent="center" bg="linear-gradient(135deg, #FAE0E4 0%, #F5EDE0 100%)" data-id="element-8">
                    <Text className="font-script" fontSize="28px" color="#C9929D" opacity={0.6} data-id="element-9">
                      Ashley Nicole
                    </Text>
                  </Box>} data-id="element-7" />
            </Box>
          </Box>

          {/* Right: Text */}
          <VStack align="flex-start" spacing={5} flex={1} data-id="element-10">
            <Text className="font-body" fontSize="11px" fontWeight={700} color="#C9929D" letterSpacing="0.2em" textTransform="uppercase" data-id="element-11">
              Meet Ashley Nicole
            </Text>

            <Text as="h2" className="font-serif" fontSize={{
            base: '28px',
            md: '36px'
          }} fontWeight={700} color="#3A3A3A" lineHeight={1.25} data-id="element-12">
              Everything About Love & xx's
            </Text>

            <Box w="50px" h="2px" bg="#F4B8C1" borderRadius="full" data-id="element-13" />

            <Text className="font-body" fontSize="16px" color="#3A3A3A" lineHeight={1.8} data-id="element-14">
              Hello! My name is Ashley Nicole and I am the owner, designer, and
              creator of Love & xx's! Ever since I was little I've always loved
              to craft and found so much joy in creating. I learned to sew when
              I was about 8 years old and started upcycling my own clothes in
              high school. When I became a teacher I was too broke to buy new
              clothes so I learned how to redesign and make my own! I quickly
              realized how terrible fast fashion and overconsumption is for our
              world and decided to find a way to make slow fashion cool again!
            </Text>
          </VStack>
        </Flex>
      </Box>

      {/* PART 2 — The Story Behind the Name */}
      <Box bg="#FFF5F6" py={20} px={{
      base: 6,
      md: 12,
      lg: 20
    }} data-id="element-15">
        <Flex maxW="1100px" mx="auto" direction={{
        base: 'column-reverse',
        md: 'row'
      }} align="center" gap={16} data-id="element-16">
          {/* Left: Text */}
          <VStack align="flex-start" spacing={5} flex={1} data-id="element-17">
            <Text as="h2" className="font-serif" fontSize={{
            base: '28px',
            md: '36px'
          }} fontWeight={700} color="#3A3A3A" lineHeight={1.25} data-id="element-18">
              The Story Behind the Name
            </Text>

            <Box w="50px" h="2px" bg="#F4B8C1" borderRadius="full" data-id="element-19" />

            <Text className="font-body" fontSize="16px" color="#3A3A3A" lineHeight={1.8} data-id="element-20">
              My nana passed away when I was 17 — she was my role model and
              biggest inspiration. She was a fashion ICON and carried herself in
              the most beautiful way. She is the inspiration behind all my
              designs, the vintage pieces I find, and the person I want to
              become. Every single card she wrote me was always signed:
            </Text>

            {/* Blockquote card */}
            <Box bg="#FAE0E4" borderRadius="12px" p={6} mt={2} borderLeft="4px solid #C9929D" w="100%" data-id="element-21">
              <Text className="font-script" fontSize={{
              base: '24px',
              md: '30px'
            }} color="#C9929D" lineHeight={1.3} data-id="element-22">
                Lots of love and xx's, Nana
              </Text>
            </Box>
          </VStack>

          {/* Right: Image */}
          <Box flex="0 0 auto" w={{
          base: '100%',
          md: '460px'
        }} maxW={{
          base: '400px',
          md: '460px'
        }} mx={{
          base: 'auto',
          md: 0
        }} data-id="element-23">
            <Box overflow="hidden" borderRadius="12px" boxShadow="0 8px 32px rgba(201,146,157,0.25)" data-id="element-24">
              <Image src="https://cdn.magicpatterns.com/uploads/uYDoXps9N7z8MfHuyQKZB7/IMG_1565.webp" alt="Vintage fashion inspiration" w="100%" h="auto" objectFit="contain" display="block" data-id="element-25" />
            </Box>
          </Box>
        </Flex>
      </Box>

      {/* PART 3 — How We Give Back */}
      <Box position="relative" overflow="hidden" py={{
      base: 20,
      md: 28
    }} data-id="element-26">
        {/* Parallax background */}
        <Box position="absolute" inset={0} bgImage="url(https://cdn.magicpatterns.com/uploads/f6CXrbwscY8HFxNohy1yxW/IMG_7080_2.webp)" bgSize="cover" bgPosition="center" bgAttachment={{
        base: 'scroll',
        md: 'fixed'
      }} data-id="element-27" />
        {/* Dark overlay */}
        <Box position="absolute" inset={0} bg="rgba(40,20,25,0.65)" data-id="element-28" />

        {/* Content */}
        <VStack position="relative" zIndex={1} align="center" spacing={6} maxW="700px" mx="auto" px={{
        base: 6,
        md: 8
      }} textAlign="center" data-id="element-29">
          <Text as="h2" className="font-serif" fontSize={{
          base: '28px',
          md: '36px'
        }} fontWeight={700} color="white" lineHeight={1.25} data-id="element-30">
            How We Give Back
          </Text>

          <Box w="60px" h="2px" bg="#F4B8C1" borderRadius="full" mx="auto" data-id="element-31" />

          <Text className="font-body" fontSize={{
          base: '16px',
          md: '17px'
        }} color="rgba(255,255,255,0.9)" lineHeight={1.8} data-id="element-32">
            Every month we take a percentage of all proceeds to buy items for
            local girls and women in need — whether that be clothes, personal
            hygiene items, school supplies, or more. By shopping at Love & xx's
            you are not only keeping clothes out of the landfills, but providing
            for women in need.
          </Text>

          <Button bg="#C9929D" color="white" fontSize="15px" fontWeight={600} px={10} h="48px" borderRadius="24px" className="font-body" _hover={{
          bg: '#b8808b',
          transform: 'translateY(-2px)'
        }} transition="all 0.25s" mt={2} data-id="element-33">
            Shop With Purpose 💕
          </Button>
        </VStack>
      </Box>
    </Box>;
}